import { AddNewStakeholderModal } from './AddNewStakeholderModal';
import { Button } from 'antd';
import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import React, { useRef } from 'react';
import { useCurrentUser, useToggle } from '@hooks';
export const AddNewStakeholderButton = () => {
    const { isReadOnly } = useCurrentUser();
    const [isOpen, toggle] = useToggle(false);
    const buttonRef = useRef(null);
    if (isReadOnly) {
        return null;
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(Button, { onClick: toggle, ref: buttonRef, type: 'primary' }, COPY_SPECIFIC.ADD_NEW_STAKEHOLDER),
        React.createElement(AddNewStakeholderModal, { isOpen: isOpen, onCancel: toggle, popoverPosition: 'bottomRight', popoverTarget: buttonRef })));
};
